export default __webpack_public_path__ + "static/media/Ride-about-logo.3e445675.png";